export interface CustomEventListener<T = any> {
  (evt: T): void;
}

export const off = <K extends keyof DocumentEventMap> (
  target: string | Element | Window | Document | EventTarget,
  eventType: K,
  listener: EventListenerOrEventListenerObject | CustomEventListener,
  options: boolean | AddEventListenerOptions = false) => {

  if (typeof target === 'string') {
    document.querySelectorAll(target).forEach(f => {
      f.removeEventListener(eventType, listener, options);
    });
  } else {
    target.removeEventListener(eventType, listener, options);
  }


}